/* Note: We noticed next.js adds an extra 'nextInternalLocale' query param when using i18n features.
This param pollutes our SEO  by duplicating content.
Our current solution is to make it so that this param doesn't appear in the DOM.
*/
export function removeNextInternalLocale(baseUrl: string, initialHref: string): string {
  const url = new URL(initialHref, baseUrl)
  const searchParams = new URLSearchParams(url.search)

  if (searchParams.has('nextInternalLocale')) {
    searchParams.delete('nextInternalLocale')
  }
  const searchParamsString = searchParams.toString()

  if (searchParamsString !== '') {
    const nextUrl = new URL(`${url.pathname}?${searchParamsString}${url.hash}`, baseUrl)
    return nextUrl.pathname + nextUrl.search + nextUrl.hash
  } else {
    const nextUrl = new URL(url.pathname + url.hash, baseUrl)
    return nextUrl.pathname + nextUrl.hash
  }
}

export function addTopAnchorAtHrefEnd(baseUrl: string, initialHref: string): string {
  const url = new URL(initialHref, baseUrl)

  if (!url.hash.includes('#top')) {
    url.hash = '#top'
  } else {
    url.href = url.href.replace('#top', '') + '#top'
  }

  return url.pathname + url.search + url.hash
}
